module.exports = __webpack_public_path__ + "img/three2Blue.971acb40.jpg";